import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, MenuController } from 'ionic-angular';
import { EndgamePage } from '../endgame/endgame';
import { Storage } from '@ionic/storage';
import { Http } from '@angular/http';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { SmartAudio } from '../../providers/smart-audio';
import { UserdataModel } from '../../providers/userdata-model';
import { GameModel } from '../../providers/game-model';
import { DataExchanger } from '../../providers/data-exchanger';

@Component({
  selector: 'page-play',
  templateUrl: 'play.html',
  host: { '(document:keydown)': 'handleKeyboardEvents($event)' }
})

export class PlayPage {

  @ViewChild('showntextscroll') private hovedInnhold : ElementRef; private scrollElement; 
  instext: string; 
  showntext:string;

  textblocks=[];
  wholetext:string;
  numSnt:number;
  numSntTotalBook:number;
  lastSentenceGuessed: string;
  lastSntToConsiderIndex:number;

  numCorretGuessesAfterWhichGiveASkip:number = 2;
  counterNumCorretGuessesAfterWhichGiveASkip: number = 0;
  
  round:number;
  attempt: number;
  scorePartial:number;
  numSbagliate: number;
  numCorrette: number;

  time:number;
  timeLeft:number;

  mood:string;

  randomGameBg:string;

  refreshIntervalId;

  constructor(public functions: Functions, public http: Http, public rubedoSideMenu: MenuController, public translate: TranslateService, public userdataModel:UserdataModel, public navCtrl: NavController, private navParams: NavParams,private storage: Storage, public playModel: GameModel, public smartAudio: SmartAudio, public dataExchanger:DataExchanger) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(false, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(false);
    
    this.mood='clueless';
  }

  /* --------- LIFECYCLE --------- */
  ionViewDidLoad(){
    //same way as ngOnInit, fires once when the view is initially loaded into the DOM
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.counterNumCorretGuessesAfterWhichGiveASkip=0;
    this.functions.changeShowSidemenuButtonTo(true);
    this.functions.stopBgMusic('app_BgMusic');
    this.randomGameBg=this.functions.getRandomGameBg();
    this.functions.startBgMusic(this.randomGameBg);
    this.begingame();
  }

  ionViewWillLeave(){
    //before the page leaves the viewport
    this.functions.setDifficulty();
    this.functions.setLanguage();
  }

  ionViewDidEnter(){
    //after the page in question becomes active
  }

  ionViewDidLeave(){
    //after the page leaves the viewport
  }

  ionViewWillUnload(){
    //before the page is removed from the DOM
  }
  /* --------- END LIFECYCLE --------- */

  /* --------- FUNCTIONS --------- */
  ngDoCheck() {
    this.scrollDownText();
  }

  splitText(textblockToSplit) {
    var splitInSntTotal: string[]=[];
    var splitInSnt: string[]=[];
    var tmpBookmark:number;
    
    // Split the text of the story in sentences
    splitInSntTotal=this.functions.splitInSentences(textblockToSplit);

    // Get the total number of sentence in this story
    this.numSntTotalBook=splitInSntTotal.length;
    this.userdataModel.setNumsnttotal(this.numSntTotalBook);
    
    // Get the current bookmark
    tmpBookmark=this.userdataModel.getBookmark();

    // Get the last sentence guessed
    if(tmpBookmark>0){
      this.lastSentenceGuessed=splitInSntTotal[tmpBookmark-1];
    }else{
      this.lastSentenceGuessed="";
    }

    // Get only the blocks necessary for this game
    // NB: Maybe in the last round we have less sentence available than numSentenceToGuessInOneRound
    this.lastSntToConsiderIndex=tmpBookmark+this.functions.numSentenceToGuessInOneRound;
    if(this.numSntTotalBook<this.lastSntToConsiderIndex){
      this.lastSntToConsiderIndex=this.numSntTotalBook;
    }

    splitInSnt=splitInSntTotal.slice(tmpBookmark, this.lastSntToConsiderIndex);

    // for every sentences
    this.numSnt=splitInSnt.length;
    this.textblocks=this.functions.getArrayTextblocks(splitInSnt,this.userdataModel.getBookmark(), this.functions.idCurrentBook);

    return;              
  }

  tryWord(){
    if(this.functions.normalizeWordForComparison(this.instext)==this.functions.normalizeWordForComparison(this.textblocks[this.round].lastWord)){
      this.functions.play('cat_collar');

      this.counterNumCorretGuessesAfterWhichGiveASkip++;
      if(this.counterNumCorretGuessesAfterWhichGiveASkip==this.numCorretGuessesAfterWhichGiveASkip){
        this.userdataModel.addSkip(1);
        this.counterNumCorretGuessesAfterWhichGiveASkip=0;
      }
      
      this.storeWordData(false, true);
      if(this.mood=='happy'){
        this.mood='superhappy';
      }else{
        this.mood='happy';
      }

      this.scorePartial++;
      this.numCorrette++; 

      this.time=this.time+5;

      if(this.round<this.numSnt){ 
        this.changeRound(); }
      if(this.round>=this.numSnt){
        this.instext='';
        this.endgame(true);
      }
    }else{
      this.functions.play('kitten_meow');
      this.storeWordData(false, false);

      if(this.mood=='sad'){
        this.mood='supersad';
      }else{
        this.mood='sad';
      }
      this.numSbagliate++;
      this.numCorrette;
    }
    this.instext='';
    this.attempt++;
    //this.scrollDown(); 
  }

  skipWord(){
    this.functions.play('kitten_meow');
    
    if(this.mood=='sad'){
      this.mood='supersad';
    }else{
      this.mood='sad';
    }
    
    this.userdataModel.useSkip();
    this.storeWordData(true, false);

    this.instext='';
    this.attempt++;
    this.changeRound();

    if(this.round>=this.numSnt){
      this.endgame(true);
    }
  }

  storeWordData(skip,correct){
    this.playModel.addWord(
        this.functions.idCurrentBook,
        this.playModel.getCurrentGameId(),
        this.round, //round
        this.attempt, //attempt
        this.userdataModel.getBookmark()+this.round, //currentBookmark
        this.time, //timeLeft
        this.userdataModel.getSkip(), //skipLeft
        this.functions.currentTimestamp(), //tsInsert
        skip, //skip
        this.instext, //word
        this.textblocks[this.round].lastWord, //wordToGuess
        correct //correct
      );
  }

  storeFinalGameData(win){
    var idGame = this.playModel.getCurrentGameId();
    this.playModel.setTsEndgame(idGame,this.functions.currentTimestamp());
    this.playModel.setScoreFinal(idGame,this.userdataModel.getScore());
    this.playModel.setSkipFinal(idGame,this.userdataModel.getSkip());
    this.playModel.setBookmarkFinal(idGame,this.userdataModel.getBookmark());
    
    this.playModel.setWin(idGame,win);
    if(this.timeLeft==-1){ this.timeLeft=this.time;}
    this.playModel.setTimeLeft(idGame,this.timeLeft);
    this.playModel.storeGamesData();
    this.dataExchanger.storeUserGamedataOnServer();
    this.dataExchanger.storeGamedataOnServer();
  }

  timer(){
    this.refreshIntervalId = setInterval(()=>{
      this.time--;
      if(this.time==10 || this.time==5){ 
        this.functions.play('tick_tock');
        this.mood='fear'; 
      }
      if(this.time==0){
        this.endgame(false);
      }
    },1000);
  }

  endgame(win){
    this.userdataModel.setScore(this.userdataModel.getScore()+this.scorePartial);
    if(win){
      this.userdataModel.setScore(this.userdataModel.getScore()+this.functions.bonusScore[this.functions.difficulty]);
    }

    this.userdataModel.setBookmark(this.userdataModel.getBookmark()+this.round);

    this.storeFinalGameData(win);

    this.navCtrl.push(EndgamePage, {
      scorePartial: this.scorePartial,
      win: win
    });

    clearInterval(this.refreshIntervalId);
    this.functions.stopBgMusic(this.randomGameBg);
  }

  giveUp(){
    this.timeLeft=this.time;
    this.time=1;
    var idGame = this.playModel.getCurrentGameId();
    this.playModel.setGiveUp(idGame, true);
  }

  begingame(){
    this.functions.getDifficulty();
    this.functions.getLanguage();

    this.round=0;
    this.attempt=1;
    this.scorePartial=0;
    //this.difficulty = navParams.get('difficulty'); 
    //this.wholetext= "Quando pensava alla popolazione non-Bene Gesserit, là fuori, per la maggior parte passiva, a volte Odrade si sentiva afferrare dall'invidia. A loro sì, era permesso illudersi. Che conforto! Si poteva fingere che la nostra vita fosse eterna, che domani sarebbe stato meglio di oggi. Che gli dei nei loro cieli vi stavano osservando pieni d'amore... Si riprese da questa caduta provando un senso di disgusto verso se stessa. L'occhio non rannuvolato era il migliore, non importava ciò che vedeva.";
    //this.wholetext= "Certo, disse la volpe. Tu, fino ad ora, per me, non sei che un ragazzino uguale a centomila ragazzini. E non ho bisogno di te. E neppure tu hai bisogno di me. Io non sono per te che una volpe uguale a centomila volpi. Ma se tu mi addomestichi, noi avremo bisogno l'uno dell'altro. Tu sarai per me unico al mondo, e io saro' per te unica al mondo.";
    
    this.instext = ''; 
    this.mood='clueless';
    this.numSbagliate=0;
    this.numCorrette=0;
    this.time=this.functions.getGameTimeAvailableAtCurrentDifficulty();
    this.timeLeft=-1;

    //this.http.get('assets/data/book1.txt').map(res => res.json()).subscribe(data=>{});

    this.http.get('assets/data/book_'+this.functions.idCurrentBook+'.txt').subscribe(data=>{
      let obj = data['_body'];
      this.splitText(obj);
        this.timer();

        this.playModel.addGame(
          this.userdataModel.userdata[0].guidUser,
          this.userdataModel.getLevel(),
          this.playModel.getNewGameId(), //idGame
          this.functions.idCurrentBook, //idBook
          this.functions.getCurrentDevice(),
          this.functions.numSentenceToGuessInOneRound, //numSntToGuess
          this.functions.currentTimestamp(), //tsTegingame
          -1, //tsTndgame
          this.functions.difficulty, //difficulty
          this.functions.language, //language
          this.userdataModel.getScore(), //scoreInitial
          -1, //scoreFinal
          this.userdataModel.getSkip(), //skipInitial
          -1, //skipFinal
          this.userdataModel.getBookmark(),
          -1,
          false,
          false, //win
          this.time, //timeLeft
          [] //wordstyped
        );  
    });

    /*this.dataExchanger.getTextblockFromServer().then((response)=>{
            var responseString:string;
            responseString=response.toString();
            if(responseString.indexOf('getTextblockFromServerIsOk')!=-1){
              this.splitText(this.functions.currentTextblock.text);
              this.timer();

              this.playModel.addGame(
                this.userdataModel.userdata[0].guidUser,
                this.userdataModel.getLevel(),
                this.playModel.getNewGameId(), //idGame
                1, //idTextblock
                this.functions.currentTimestamp(), //tsTegingame
                0, //tsTndgame
                this.functions.difficulty, //difficulty
                this.functions.language, //language
                this.userdataModel.getScore(), //scoreInitial
                0, //scoreFinal
                this.functions.skip, //skipInitial
                0, //skipFinal
                false,
                false, //win
                this.time, //timeLeft
                [] //wordstyped
              );  
              //TODO loading and errors
              //this.loader.dismiss();
            }else{
              //this.errorMessage=this.auth.errorMessage;
              //this.loader.dismiss();
            }
          });*/
    //this.wholetext = "Da pochi giorni un uomo è diventato padre. Inizia a scrivere in un quaderno per il figlio. Vuole parlargli delle cose importanti della vita: che cos'è l'amore, che cosa sono i soldi, che cos'è il potere, raccontandoglieli per come li ha conosciuti lui, personalmente. Gli consegnerà questo scritto quando il figlio compirà quattordici anni: l'età in cui i figli cominciano a detestare i padri, anche perchè si accorgono che i padri non gli hanno detto come funziona veramente il mondo."

  }

  getProgress(){
    var progress=0;
    progress=Math.floor(((this.userdataModel.getBookmark()+this.round)/this.numSntTotalBook)*100);
    return progress;
  }

  changeRound(){
    //if(num){
    //  this.round=num;
    //}else{
      this.round++;
    //}
  }

  scrollDownText(){
    this.scrollElement = this.hovedInnhold.nativeElement;
    
    /*console.log("scroll down");
    console.log(this.scrollElement.scrollHeight);
    console.log(this.hovedInnhold.nativeElement.scrollTop);*/

    this.hovedInnhold.nativeElement.scrollTop = this.scrollElement.scrollHeight;
  }

  keyPressed(keyChosen){
    if(keyChosen=='delete'){
      this.instext=this.instext.substring(0, this.instext.length - 1)
    }else{
      this.instext+=keyChosen;
    }
  }

  handleKeyboardEvents(event: KeyboardEvent) {
      //keyCode = key pressed w=W
      //which = ascii cose w!=W
      //var res = String.fromCharCode(event.which);
      
      // this avoid enter and space to add extra character after a button is used and so focused
      event.preventDefault();
      event.stopPropagation();

      if(this.isCharacterKeyPress(event)){
        var characterPressed=this.functions.normalizeWordForComparison(event.key);
        this.keyPressed(characterPressed);
        document.getElementById(characterPressed).classList.add('colorgrey');
        var clickAnimationIntervalId = setInterval(function(){document.getElementById(characterPressed).classList.remove('colorgrey'); clearInterval(clickAnimationIntervalId);},300);
        document.getElementById(characterPressed).blur();
      }
      if(event.which == 8){
        this.keyPressed('delete');
        document.getElementById('delete').classList.add('colorgrey');
        var clickAnimationIntervalId = setInterval(function(){document.getElementById('delete').classList.remove('colorgrey'); clearInterval(clickAnimationIntervalId); clearInterval(this.clickAnimationIntervalId);},300);
        document.getElementById('delete').blur();
      }

      if(event.which == 13){
        this.tryWord();
        document.getElementById('try').classList.add('colorgrey');
        var clickAnimationIntervalId = setInterval(function(){document.getElementById('try').classList.remove('colorgrey'); clearInterval(clickAnimationIntervalId); clearInterval(this.clickAnimationIntervalId);},300);
        document.getElementById('try').blur();
      }
  }

  isCharacterKeyPress(event) {
    var accentedLettersRegexp = /[áéíóúÁÉÍÓÚàèìòùÁÉÍÓÚ]/;
    var isAccentedLetter=accentedLettersRegexp.test(event.key);
    /*if (typeof event.which == "undefined") {
        // This is IE, which only fires keypress events for printable keys
        return true;
    } else*/
    if (
      (event.which >= 65 && event.which <= 90) // A-Z  
      || (event.which >= 97 && event.which <= 122)
      || isAccentedLetter
      )  {
        return true;
    }
    return false;
  }
  
  /* --------- END FUNCTIONS --------- */
}



// WEBPACK FOOTER //
// ./src/pages/play/play.ts